export class Child {
  id?: string;
  name!: string;
  firstSurname!: string;
  secondSurname!: string;
  birthDate!: string;
}
